import { ComponentChildren, CSSProperties } from "preact";
import { forwardRef } from "preact/compat";

type ButtonProps = {
  onClick: (e: preact.TargetedMouseEvent<HTMLButtonElement>) => void;
  children: ComponentChildren;
  style?: CSSProperties;
  disabled?: boolean;
  className?: string;
  onMouseDown?: (e: preact.TargetedMouseEvent<HTMLButtonElement>) => void;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ style, children, disabled, onClick, onMouseDown, className }, ref) => (
    <button
      className={"button " + (className || "")}
      type="button"
      onMouseDown={onMouseDown}
      style={style}
      disabled={disabled}
      ref={ref}
      onClick={onClick}
    >
      {children}
    </button>
  ),
);
